// App shell for the standalone boards: the left navigation drawer plus the
// app's standard page layout, so a board sits inside the app and reads like
// every other page rather than painting its own chrome.
//
// PageLayout supplies the white card, the 15 px radius and the page margins —
// templates render their content straight into it and must not re-draw a page
// ground of their own.
//
// The card is pinned to the viewport rather than sized by its content: the
// window never scrolls vertically, and the board scrolls inside its own
// BoardScrollArea instead, so the tabs and each board's filter row stay put.
// That is how the skills matrix and jobs matrix pages behave.
//
// The card is design/wilya-page-layout's card — the same margins, ground and
// radius — without its 1364 px minimum width. On a laptop at 150 % scaling the
// window is narrower than that, and the minimum made the whole page scroll
// sideways, cutting the right edge of every tab off. The board's wide blocks
// (the week grids, the tables) each scroll inside their own box instead.
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";

import colors from "../../../../config/colors";
import {
	changeSelectedMenuItemId,
	closeNavigationDrawer,
} from "../../../../features/navigation-drawer/navigation-drawer-slice";
import NavDrawer from "../../../drawer/ui";

export function BoardShell({
	menuId,
	children,
}: {
	menuId: number
	children: React.ReactNode
}) {
	const dispatch = useDispatch();
	useEffect(() => {
		dispatch(changeSelectedMenuItemId(menuId));
		dispatch(closeNavigationDrawer());
	}, [dispatch, menuId]);
	return (
		<Box sx={{ display: "flex", backgroundColor: colors.pageBackground }}>
			<CssBaseline />
			<NavDrawer keepSettingOpen={false} keepReportOpen={false} />
			<Box
				sx={{
					flexGrow: 1,
					minWidth: 0,
					height: "100vh",
					display: "flex",
					overflowX: "auto",
					overflowY: "hidden",
				}}
			>
				<Box
					component='main'
					sx={{ flexGrow: 1, minWidth: 0, m: 3, backgroundColor: colors.light, borderRadius: "15px" }}
				>
					{/* the card is stretched to the viewport by the row above;
					    this column is what hands that height to the board */}
					<Box
						sx={{
							display: "flex",
							flexDirection: "column",
							height: "100%",
							minHeight: 0,
							minWidth: 0,
						}}
					>
						{children}
					</Box>
				</Box>
			</Box>
		</Box>
	);
}
